import { Box, CircularProgress, useTheme, Stack } from "@mui/material"
import { CircularProgressProps } from "@mui/material/CircularProgress"
import { MotionDiv } from "components/motions"
import { Image } from "components/Image"

const LoadingCircularProgress = (props: CircularProgressProps) => {
  const theme = useTheme()
  const styleOverrides = theme.components[`LoadingScreen`]?.styleOverrides || {}
  const { loadingTrack, loadingIndicator, loadingRoot } = styleOverrides
  return (
    <Box sx={loadingRoot}>
      <CircularProgress
        variant="determinate"
        sx={loadingTrack}
        size={350}
        thickness={1.25}
        {...props}
        value={100}
      />
      <CircularProgress
        variant="indeterminate"
        sx={loadingIndicator}
        size={350}
        thickness={1.25}
        {...props}
      />
    </Box>
  )
}

export const LoadingScreen = (props) => {
  const theme = useTheme()
  const { loadingScreen } = theme.assets || {}
  const styleOverrides = theme.components[`LoadingScreen`]?.styleOverrides || {}
  const { root, logo: logoStyle, backgroundLoading } = styleOverrides

  return (
    <MotionDiv
      variants={loadingScreen}
      initial="initial"
      animate="enter"
      exit="exit"
      sx={root}
      className="loading-screen"
      {...props}
    >
      <Stack alignItems="center">
        <LoadingCircularProgress />
        {loadingScreen.url && (
          <Image src={loadingScreen.url} alt="Logo" sx={logoStyle} />
        )}
      </Stack>
      <Box sx={backgroundLoading}></Box>
    </MotionDiv>
  )
}
